import { render, staticRenderFns } from "./CollectiveClass.vue?vue&type=template&id=b7e4b1fe&scoped=true"
import script from "./CollectiveClass.vue?vue&type=script&lang=js"
export * from "./CollectiveClass.vue?vue&type=script&lang=js"
import style0 from "./CollectiveClass.vue?vue&type=style&index=0&id=b7e4b1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e4b1fe",
  null
  
)

export default component.exports